export default __webpack_public_path__ + "static/Header-52c26580f1195466c450a83dcaa03abd.png";